

























































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { PaymentsModule } from '@/store/modules/payments.module'
import Icon from '@/components/Icon.vue'
import {
  EAutoPayType,
  ESchedulePaymentItemType,
  ITransactionToPay
} from '@zunta/configurations'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { plus, getAutopayTooltipText } from '@/utils/helpers'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'

@Component({
  props: {
    scheduleItem: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    DateTimeLabel,
    Icon,
    ResidentLabel
  }
})
export default class ReviewInfo extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  ESchedulePaymentItemType: any = ESchedulePaymentItemType
  EAutoPayType: any = EAutoPayType
  getAutopayTooltipText = getAutopayTooltipText

  get scheduleSettingStatistics () {
    return this.$store.state.payments.scheduleSettingStatistics
  }

  get transactionsToApply () {
    return this.$store.state.payments.transactionsToApply
  }

  get totalChargeAmount () {
    return this.transactionsToApply
      .reduce(
        (total: number, transaction: ITransactionToPay) =>
          plus(total, transaction.amount as number),
        0)
  }
}
